"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _ChartWidget = _interopRequireDefault(require("../../../components/shared-components/ChartWidget"));

var _GoalWidget = _interopRequireDefault(require("../../../components/shared-components/GoalWidget"));

var _axios = _interopRequireDefault(require("axios"));

var _config = _interopRequireDefault(require("../../../config.json"));

var _utils = _interopRequireDefault(require("../../../utils"));

var _errorPage = _interopRequireDefault(require("../../error-views/errorPage"));

var _RmName = _interopRequireDefault(require("../../../RmName.json"));

// import { Link } from 'react-router-dom';
var date = new Date();
var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']; //const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

var VisitorChartData = {
  series: [{
    name: "Math RR %",
    data: []
  }, {
    name: "English RR %",
    data: []
  }, {
    name: "English PR %",
    data: []
  }, {
    name: "Math PR %",
    data: []
  }],
  categories: []
};

var Home = function Home() {
  var cl = localStorage.getItem("CL");
  var token = localStorage.getItem("token");

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      Loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      apiError = _useState4[0],
      setapiError = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      absent = _useState6[0],
      setAbsent = _useState6[1];

  var _useState7 = (0, _react.useState)([]),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      allAttendance = _useState8[0],
      setAllattendance = _useState8[1];

  var _useState9 = (0, _react.useState)([]),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      data = _useState10[0],
      setData = _useState10[1];

  var _useState11 = (0, _react.useState)([]),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      data1 = _useState12[0],
      setData1 = _useState12[1];

  (0, _react.useEffect)(function () {
    VisitorChartData = {
      series: [{
        name: "Math RR %",
        data: []
      }, {
        name: "English RR %",
        data: []
      }, {
        name: "English PR %",
        data: []
      }, {
        name: "Math PR %",
        data: []
      }],
      categories: []
    };
    fetchData(); // eslint-disable-next-line
  }, []);

  function fetchData() {
    return _fetchData.apply(this, arguments);
  }

  function _fetchData() {
    _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var url, url1, url3, url4;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = _config.default.getEnrollDropRes + cl;
              _context.next = 3;
              return _axios.default.get(url, {
                headers: {
                  'Authorization': token
                }
              }).then(function (resp) {
                if (resp.data.status === "error") setapiError(resp.data);else {
                  var details = resp.data;
                  setData(details);
                }
              }, function (err) {
                var obj = {
                  "status": "error",
                  "message": "Network Error"
                };
                if (err.response) setapiError(err.response);else setapiError(obj);
              });

            case 3:
              url1 = _config.default.getabsentRM + cl;
              _context.next = 6;
              return _axios.default.get(url1, {
                headers: {
                  'Authorization': token
                }
              }).then(function (resp) {
                if (resp.data.status === "error") setapiError(resp.data);else {
                  var attendance = resp.data.filter(function (res, index) {
                    return res.Attendance === 'नहीं';
                  });
                  setAbsent(attendance);
                  setAllattendance(resp.data);
                }
              }, function (err) {
                var obj = {
                  "status": "error",
                  "message": "Network Error"
                };
                if (err.response) setapiError(err.response);else setapiError(obj);
              });

            case 6:
              url3 = _config.default.getOneWeekResponse + cl;
              _context.next = 9;
              return _axios.default.get(url3, {
                headers: {
                  'Authorization': token
                }
              }).then(function (resp) {
                if (resp.data.status === "error") setapiError(resp.data);else {
                  resp.data.map(function (obj) {
                    obj.MathRRRatio = obj.MathRRRatio ? obj.MathRRRatio.toFixed(2) : 0;
                    obj.EngRRRatio = obj.EngRRRatio ? obj.EngRRRatio.toFixed(2) : 0;
                    obj.EngPR = obj.EngPR ? obj.EngPR.toFixed(2) : 0;
                    obj.MathPR = obj.MathPR ? obj.MathPR.toFixed(2) : 0; // obj.today_s_date=dateFormate(obj.today_s_date.value);

                    obj.Date = dateFormate(obj.Date);
                    VisitorChartData.series[0].data.push(obj.MathRRRatio);
                    VisitorChartData.series[1].data.push(obj.EngRRRatio);
                    VisitorChartData.series[2].data.push(obj.EngPR);
                    VisitorChartData.series[3].data.push(obj.MathPR);
                    VisitorChartData.categories.push(dateFormate(obj.Date));
                  });
                  setLoading(false);
                }
              }, function (err) {
                var obj = {
                  "status": "error",
                  "message": "Network Error"
                };
                if (err.response) setapiError(err.response);else setapiError(obj);
              });

            case 9:
              url4 = _config.default.getStudentRPW + cl;
              _context.next = 12;
              return _axios.default.get(url4, {
                headers: {
                  'Authorization': token
                }
              }).then(function (resp) {
                if (resp.data.status === "error") setapiError(resp.data);else {
                  var details = resp.data;
                  setData1(details);
                  setLoading(false);
                }
              }, function (err) {
                var obj = {
                  "status": "error",
                  "message": "Network Error"
                };
                if (err.response) setapiError(err.response);else setapiError(obj);
              });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _fetchData.apply(this, arguments);
  }

  function dateFormate(changeDate) {
    var date = new Date(changeDate);
    var year = date.getFullYear();
    var month = ("0" + (date.getMonth() + 1)).slice(-2);
    var day = ("0" + date.getDate()).slice(-2);
    var todayDate = "".concat(year, "-").concat(month, "-").concat(day);
    return todayDate;
  }

  var columns = [{
    title: "".concat(_RmName.default.name, " code"),
    dataIndex: "RM_code",
    key: "RM_code",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'RM_code');
    }
  }, {
    title: "Contact",
    dataIndex: "Phone_Number",
    key: "Phone_Number",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Phone_Number');
    }
  }];
  return apiError ? /*#__PURE__*/_react.default.createElement(_errorPage.default, {
    details: apiError
  }) : Loading ? /*#__PURE__*/_react.default.createElement(_antd.Spin, {
    tip: "Loading..."
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    style: {
      margin: 0,
      marginBottom: 2
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [4, 4],
    style: {
      fontWeight: 'bold',
      fontSize: '16px'
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 6,
    sm: 6,
    md: 6,
    lg: 6,
    xl: 6,
    xxl: 6,
    className: "text-center"
  }, "CL-", cl), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 6,
    sm: 6,
    md: 6,
    lg: 6,
    xl: 6,
    xxl: 6,
    className: "text-center"
  }, days["".concat(date.getDay())]), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 6,
    xl: 6,
    xxl: 6,
    className: "text-center"
  }, date.getDate() < 10 ? '0' + date.getDate() : date.getDate(), "-", date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1, "-", date.getFullYear()), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 6,
    xl: 6,
    xxl: 6,
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    type: "link",
    onClick: function onClick() {
      return window.open("https://datastudio.google.com/reporting/26ad324e-383a-462c-8d8f-f2d2ba154582/page/DxKtB");
    }
  }, "See Report on Data Studio")))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [4, 4]
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 18,
    xl: 18,
    xxl: 18
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [4, 4]
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 6,
    xl: 7,
    xxl: 7
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Enrollment Request",
    style: {
      margin: 0,
      marginTop: 6,
      marginBottom: 5,
      marginRight: 2,
      height: 95
    }
  }, /*#__PURE__*/_react.default.createElement("h4", null, data.EnrollmentRequest))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 6,
    xl: 7,
    xxl: 7
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Dropout Request",
    style: {
      margin: 0,
      marginTop: 6,
      marginBottom: 5,
      marginRight: 2,
      height: 95
    }
  }, /*#__PURE__*/_react.default.createElement("h4", null, data.DropoutRequest))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 6,
    xl: 10,
    xxl: 10
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Yesterday Response Rate",
    style: {
      margin: 0,
      marginTop: 6,
      marginBottom: 5,
      marginRight: 2,
      height: 95
    }
  }, /*#__PURE__*/_react.default.createElement("h4", null, data.RR ? data.RR + "%" : "No Data Found"))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 6,
    xl: 10,
    xxl: 10
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Yesterday Progress Rate",
    style: {
      margin: 0,
      marginTop: 6,
      marginBottom: 5,
      marginRight: 2,
      height: 95
    }
  }, /*#__PURE__*/_react.default.createElement("h4", null, data1.YesterdayPR + "%")))), /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 24,
    xl: 24,
    xxl: 24
  }, /*#__PURE__*/_react.default.createElement(_ChartWidget.default, {
    title: "CL Last Week Response Rate",
    series: VisitorChartData.series,
    xAxis: VisitorChartData.categories,
    height: 480
  })))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 6,
    xl: 6,
    xxl: 6,
    className: "text-right",
    style: {
      margin: 0,
      marginTop: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_GoalWidget.default, {
    title: "Today's ".concat(_RmName.default.name, "'s Attendance"),
    value: Math.round((allAttendance.length - absent.length) / allAttendance.length * 100),
    subtitle: absent.length === 0 ? // `आज कोई अनुपस्थित नहीं है`
    "All ".concat(_RmName.default.name, "'s are present") : // `आज ${absent.length} आरएम अनुपस्थित हैं`
    "".concat(absent.length, " ").concat(_RmName.default.name, "'s are absent") // extra={
    // 	<Link to='/clPortal/app/rm/all'>
    // 		<Button type="primary">
    // 			All RM
    // 		</Button>
    // 	</Link>
    // }
    ,
    style: {
      margin: 0
    }
  }), /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Today's Absent ".concat(_RmName.default.name, "'s"),
    className: "text-center",
    style: {
      margin: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Table, {
    dataSource: absent,
    columns: columns
  })))));
};

var _default = Home;
exports.default = _default;